import React from "react";
import i18n from "../../i18n";
import swal from "sweetalert";
import '../../styles/components/auth-page.scss';
import { resendEmailOTP, verifyEmailOTP } from "../../models/users";

export class VerifiyOtp extends React.Component {
    constructor() {
        super();

        this.state = {
            otp: ["", "", "", "", "", ""],
            timer: 60,
            canResend: false,
            isLoading: false,
            isVerifying: false,
            activeInput: 0,
            verificationToken: "",
            errorMessage: "",
            successMessage: ""
        };
        this.otpRefs = Array(6).fill().map(() => React.createRef());
        this.timerInterval = null;
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // Extract token from URL
        this.extractTokenFromURL();

        this.startTimer();

        // Focus first input
        setTimeout(() => {
            if (this.otpRefs[0].current) {
                this.otpRefs[0].current.focus();
            }
        }, 100);
    }

    componentWillUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    extractTokenFromURL = () => {
        try {
            const path = window.location.pathname; // e.g., "/verify-otp/FCjMHq44EhaaFZqn22ZKwOngB8otXHPE2iKeXIcnjFBJBl3WXxhYPjA3NzNk"
            console.log("Full pathname:", path);

            // Remove leading/trailing slashes and split
            const cleanPath = path.replace(/^\/|\/$/g, '');
            const pathParts = cleanPath.split('/');

            console.log("Path parts:", pathParts);

            // Path should be: ["verify-otp", "token"]
            if (pathParts.length >= 2 && pathParts[0] === "verify-otp") {
                const token = pathParts[1];
                console.log("Extracted token:", token);

                if (token && token.length > 10) {
                    this.setState({ verificationToken: token });
                    console.log("Token set in state:", token);
                } else {
                    this.setState({
                        errorMessage: "Invalid verification token. Please try logging in again."
                    });
                    console.error("Token too short:", token);
                }
            } else {
                this.setState({
                    errorMessage: "Invalid verification link format."
                });
                console.error("Invalid path format:", pathParts);
            }

        } catch (error) {
            console.error("Error extracting token:", error);
            this.setState({
                errorMessage: "Invalid verification link."
            });
        }
    };

    startTimer = () => {
        this.timerInterval = setInterval(() => {
            this.setState(prevState => {
                if (prevState.timer <= 1) {
                    clearInterval(this.timerInterval);
                    return { timer: 0, canResend: true };
                }
                return { timer: prevState.timer - 1 };
            });
        }, 1000);
    };

    handleOtpChange = (index, value) => {
        this.setState({ errorMessage: "", successMessage: "" });

        if (!/^\d*$/.test(value)) return;

        const newOtp = [...this.state.otp];
        newOtp[index] = value;
        this.setState({ otp: newOtp, activeInput: index });

        if (value && index < 5) {
            setTimeout(() => {
                if (this.otpRefs[index + 1].current) {
                    this.otpRefs[index + 1].current.focus();
                }
            }, 10);
        }
    };

    handleKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === "Backspace") {
            if (!this.state.otp[index] && index > 0) {
                // Move to previous input
                const newOtp = [...this.state.otp];
                newOtp[index - 1] = "";
                this.setState({ otp: newOtp }, () => {
                    if (this.otpRefs[index - 1].current) {
                        this.otpRefs[index - 1].current.focus();
                    }
                });
            } else {
                // Clear current input
                const newOtp = [...this.state.otp];
                newOtp[index] = "";
                this.setState({ otp: newOtp });
            }
        }

        // Handle arrow keys
        if (e.key === "ArrowLeft" && index > 0) {
            if (this.otpRefs[index - 1].current) {
                this.otpRefs[index - 1].current.focus();
            }
        }
        if (e.key === "ArrowRight" && index < 5) {
            if (this.otpRefs[index + 1].current) {
                this.otpRefs[index + 1].current.focus();
            }
        }

        // Handle Enter key to submit
        if (e.key === "Enter" && this.state.otp.join('').length === 6) {
            this.validateOtp();
        }
    };

    handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text/plain").trim();

        if (/^\d{6}$/.test(pastedData)) {
            const otpArray = pastedData.split("");
            this.setState({
                otp: otpArray,
                errorMessage: "",
                successMessage: ""
            }, () => {
                // Focus last input
                if (this.otpRefs[5].current) {
                    this.otpRefs[5].current.focus();
                }
            });
        }
    };

    handleResendOtp = async () => {
        if (!this.state.canResend || this.state.isLoading || !this.state.verificationToken) {
            console.log("Cannot resend:", {
                canResend: this.state.canResend,
                isLoading: this.state.isLoading,
                token: this.state.verificationToken
            });
            return;
        }

        this.setState({ isLoading: true, errorMessage: "", successMessage: "" });

        try {
            console.log("Resending OTP with token:", this.state.verificationToken);
            const response = await resendEmailOTP({
                verification_token: this.state.verificationToken
            });

            console.log("Resend response:", response);

            if (response && response.success) {
                this.setState({
                    timer: 60,
                    canResend: false,
                    otp: ["", "", "", "", "", ""],
                    activeInput: 0,
                    isLoading: false,
                    successMessage: response.message || "New OTP sent to your email."
                }, () => {
                    this.startTimer();
                    if (this.otpRefs[0].current) {
                        this.otpRefs[0].current.focus();
                    }
                });
            } else {
                this.setState({
                    errorMessage: response?.message || "Failed to resend OTP.",
                    isLoading: false
                });
            }
        } catch (error) {
            console.error("Resend OTP error:", error);
            this.setState({
                errorMessage: error.message || "Failed to resend OTP.",
                isLoading: false
            });
        }
    };

    validateOtp = async () => {
        const otpString = this.state.otp.join("");

        console.log("Validating OTP:", otpString);
        console.log("Using token:", this.state.verificationToken);

        if (otpString.length !== 6) {
            this.setState({ errorMessage: "Please enter complete 6-digit OTP" });
            return;
        }

        if (!this.state.verificationToken) {
            this.setState({
                errorMessage: "Invalid verification session. Please try logging in again."
            });
            return;
        }

        this.setState({ isVerifying: true, errorMessage: "", successMessage: "" });

        try {
            console.log("Calling verifyEmailOTP API...");
            const response = await verifyEmailOTP({
                verification_token: this.state.verificationToken,
                otp: otpString
            });

            console.log("Full API Response:", response);
            console.log("Response data:", response?.data);
            console.log("Response success:", response?.success);

            // Check if response is null or undefined
            if (!response) {
                throw new Error("No response received from server");
            }

            if (!response.success) {
                this.setState({
                    errorMessage: response.message || "Invalid OTP. Please try again.",
                    otp: ["", "", "", "", "", ""],
                    isVerifying: false
                }, () => {
                    if (this.otpRefs[0].current) {
                        this.otpRefs[0].current.focus();
                    }
                });
                return;
            }

            // Check if token exists in response
            if (response.data?.token) {
                console.log("Token found in response:", response.data.token);
                console.log("User data:", response.data.user || response.data);

                this.setState({
                    successMessage: "Email verified successfully! Redirecting...",
                    isVerifying: false
                });

                // Store authentication data
                localStorage.setItem("is_logged_in", "true");
                localStorage.setItem("token", response.data.token);

                // Store user info
                const userData = response.data.user || response.data;
                localStorage.setItem("mzad_user_info", JSON.stringify(userData));

                console.log("LocalStorage set:", {
                    token: response.data.token,
                    user: userData
                });

                // Redirect
                setTimeout(() => {
                    const role = userData.role || (userData.user ? userData.user.role : null);
                    const redirectPath = role === "A" ? "/dashboard" : "/";
                    console.log("Redirecting to:", redirectPath);
                    window.location.href = redirectPath;
                }, 1500);

            } else {
                console.error("No token in response:", response);
                this.setState({
                    errorMessage: "Verification succeeded but no authentication token received. Please contact support.",
                    isVerifying: false
                });
            }

        } catch (error) {
            console.error("OTP verification error:", error);
            console.error("Error details:", {
                message: error.message,
                response: error.response,
                data: error.response?.data
            });

            let errorMsg = "Failed to verify OTP. ";

            if (error.response?.data?.message) {
                errorMsg += error.response.data.message;
            } else if (error.message) {
                errorMsg += error.message;
            } else {
                errorMsg += "Please check your connection and try again.";
            }

            this.setState({
                errorMessage: errorMsg,
                isVerifying: false
            });
        }
    }; dateOtp = async () => {
        const otpString = this.state.otp.join("");

        if (otpString.length !== 6) {
            this.setState({ errorMessage: "Please enter complete 6-digit OTP" });
            return;
        }

        if (!this.state.verificationToken) {
            this.setState({
                errorMessage: "Invalid verification session. Please try logging in again."
            });
            return;
        }

        this.setState({ isVerifying: true, errorMessage: "", successMessage: "" });

        try {
            const response = await verifyEmailOTP({
                verification_token: this.state.verificationToken,
                otp: otpString
            });

            console.log("OTP verification response:", response); // Debug

            if (!response.success) {
                // Check for specific error cases
                if (response.message?.includes("Invalid OTP") || response.message?.includes("invalid")) {
                    this.setState({
                        errorMessage: response.message || "Invalid OTP. Please try again.",
                        otp: ["", "", "", "", "", ""],
                        isVerifying: false
                    }, () => {
                        // Focus first input after error
                        if (this.otpRefs[0].current) {
                            this.otpRefs[0].current.focus();
                        }
                    });
                } else if (response.message?.includes("expired") || response.message?.includes("session")) {
                    this.setState({
                        errorMessage: "Verification session expired. Please login again.",
                        isVerifying: false
                    });
                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 3000);
                } else {
                    this.setState({
                        errorMessage: response.message || "Verification failed. Please try again.",
                        isVerifying: false
                    });
                }
                return;
            }

            // Successful verification
            if (response.data?.token) {
                this.setState({
                    successMessage: "Email verified successfully! Redirecting...",
                    isVerifying: false
                });

                // Store authentication data
                localStorage.setItem("is_logged_in", "true");
                localStorage.setItem("token", response.data.token);

                // Store user info if available
                if (response.data.user) {
                    localStorage.setItem("mzad_user_info", JSON.stringify(response.data.user));
                } else if (response.data) {
                    localStorage.setItem("mzad_user_info", JSON.stringify(response.data));
                }

                // Redirect after delay
                setTimeout(() => {
                    const redirectPath = (response.data.role === "A" ||
                        response.data.user?.role === "A")
                        ? "/dashboard"
                        : "/";
                    window.location.href = redirectPath;
                }, 1500);

            } else {
                this.setState({
                    errorMessage: "Invalid response from server. Missing authentication token.",
                    isVerifying: false
                });
            }

        } catch (error) {
            console.error("OTP verification error:", error);
            this.setState({
                errorMessage: error.message || "Failed to verify OTP. Please check your connection and try again.",
                isVerifying: false
            });
        }
    };

    handleBackToLogin = () => {
        window.location.href = "/login";
    };

    render() {
    const { otp, timer, canResend, isLoading, isVerifying, activeInput, 
                errorMessage, successMessage, verificationToken } = this.state;

        console.log("Current state:", {
            verificationToken,
            otp: otp.join(''),
            isVerifying
        });

        return (
            <div className="vh-100 d-flex">
                {/* Left Side - OTP Form */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
                    <div className="w-100" style={{ maxWidth: "450px", padding: "2rem" }}>
                        <div className="text-center mb-4">
                            <div className="icon-circle mb-3">
                                <i className="fas fa-envelope fa-3x"></i>
                            </div>
                            <h2 className="fw-bold text-dark mb-2" style={{ fontSize: "2rem" }}>
                                {i18n.t('verify_your_email') || "Verify Your Email"}
                            </h2>
                            <p className="text-muted">
                                Enter the 6-digit verification code sent to your email
                            </p>

                            {/* Success Message */}
                            {successMessage && (
                                <div className="alert alert-success py-2 mt-2" role="alert">
                                    <i className="fas fa-check-circle me-2"></i>
                                    {successMessage}
                                </div>
                            )}

                            {/* Error Message */}
                            {errorMessage && (
                                <div className="alert alert-danger py-2 mt-2" role="alert">
                                    <i className="fas fa-exclamation-circle me-2"></i>
                                    {errorMessage}
                                </div>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-medium mb-3 d-block text-center">
                                Enter Verification Code
                            </label>

                            <div className="otp-container mb-4">
                                <div className="otp-inputs">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={this.otpRefs[index]}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => this.handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => this.handleKeyDown(index, e)}
                                            onPaste={this.handlePaste}
                                            onFocus={() => this.setState({ activeInput: index })}
                                            className={`otp-box ${activeInput === index ? 'active' : ''} ${digit ? 'filled' : ''}`}
                                            autoFocus={index === 0}
                                            disabled={isVerifying}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="text-center mb-4">
                                <button
                                    onClick={this.handleResendOtp}
                                    disabled={!canResend || isLoading || isVerifying}
                                    className="btn btn-link"
                                    style={{
                                        color: canResend ? '#189397' : '#6c757d',
                                        textDecoration: 'none',
                                        fontSize: '14px'
                                    }}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Sending...
                                        </>
                                    ) : canResend ? (
                                        <><i className="fas fa-redo me-2"></i> Resend Code</>
                                    ) : (
                                        `Resend code in ${timer}s`
                                    )}
                                </button>
                            </div>

                            <button
                                onClick={this.validateOtp}
                                disabled={isVerifying || otp.join('').length !== 6}
                                className="btn w-100 text-white fw-medium py-3"
                                style={{
                                    backgroundColor: isVerifying ? '#0d6efd' : "#189397",
                                    border: "none",
                                    borderRadius: "10px",
                                    fontSize: "16px",
                                    transition: "all 0.3s"
                                }}
                            >
                                {isVerifying ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Verifying...
                                    </>
                                ) : (
                                    "Verify & Continue"
                                )}
                            </button>
                        </div>

                        <div className="text-center mt-4">
                            <button
                                onClick={this.handleBackToLogin}
                                className="btn btn-link"
                                style={{ color: '#6c757d', textDecoration: 'none' }}
                                disabled={isVerifying}
                            >
                                <i className="fas fa-arrow-left me-2"></i>
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right Side - Banner */}
                <div
                    className="col-lg-6 d-none d-lg-block position-relative"
                    style={{
                        backgroundImage: `linear-gradient(135deg, rgba(24,147,151,0.8) 0%, rgba(189,197,50,0.8) 100%),url('/assets/images/auth/banner-1.jpeg')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    <div className="position-absolute top-50 start-50 translate-middle text-white text-center w-75">
                        <div className="mb-4">
                            <i className="fas fa-shield-alt fa-4x mb-3 opacity-75"></i>
                            <h2 className="fw-bold mb-3">Secure Email Verification</h2>
                            <p className="fs-5 opacity-90">
                                We've sent a one-time password to your email to ensure your account security.
                            </p>
                        </div>

                        <div className="verification-steps">
                            <div className="step-item">
                                <div className="step-icon">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div className="step-text">
                                    <h5>1. Check Email</h5>
                                    <p>Look for OTP in your inbox</p>
                                </div>
                            </div>
                            <div className="step-arrow">
                                <i className="fas fa-arrow-right"></i>
                            </div>
                            <div className="step-item">
                                <div className="step-icon">
                                    <i className="fas fa-key"></i>
                                </div>
                                <div className="step-text">
                                    <h5>2. Enter 6-digit Code</h5>
                                    <p>Type the code exactly as shown</p>
                                </div>
                            </div>
                            <div className="step-arrow">
                                <i className="fas fa-arrow-right"></i>
                            </div>
                            <div className="step-item">
                                <div className="step-icon">
                                    <i className="fas fa-check-circle"></i>
                                </div>
                                <div className="step-text">
                                    <h5>3. Access Granted</h5>
                                    <p>Start using all features</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Add CSS Styles */}
                <style>{`
                    .icon-circle {
                        width: 100px;
                        height: 100px;
                        background: linear-gradient(135deg, #189397 0%, #bdc532 100%);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 auto 20px;
                        color: white;
                        box-shadow: 0 5px 15px rgba(24, 147, 151, 0.3);
                    }
                    
                    .otp-container {
                        display: flex;
                        justify-content: center;
                        padding: 20px 0;
                    }
                    
                    .otp-inputs {
                        display: flex;
                        gap: 12px;
                    }
                    
                    .otp-box {
                        width: 55px;
                        height: 65px;
                        text-align: center;
                        font-size: 28px;
                        font-weight: 600;
                        border: 2px solid #dee2e6;
                        border-radius: 12px;
                        background-color: #f8f9fa;
                        color: #212529;
                        transition: all 0.3s;
                        outline: none;
                    }
                    
                    .otp-box:focus, .otp-box.active {
                        border-color: #189397;
                        box-shadow: 0 0 0 3px rgba(24, 147, 151, 0.2);
                        background-color: white;
                        transform: translateY(-2px);
                    }
                    
                    .otp-box.filled {
                        border-color: #189397;
                        background-color: #f0f9fa;
                    }
                    
                    .otp-box:disabled {
                        background-color: #e9ecef;
                        opacity: 0.7;
                        cursor: not-allowed;
                    }
                    
                    .verification-steps {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 20px;
                        margin-top: 40px;
                    }
                    
                    .step-item {
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        background: rgba(255, 255, 255, 0.1);
                        padding: 15px;
                        border-radius: 15px;
                        min-width: 180px;
                        backdrop-filter: blur(10px);
                    }
                    
                    .step-icon {
                        width: 50px;
                        height: 50px;
                        background: rgba(255, 255, 255, 0.2);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 20px;
                    }
                    
                    .step-text h5 {
                        margin: 0;
                        font-size: 14px;
                        font-weight: 600;
                    }
                    
                    .step-text p {
                        margin: 5px 0 0;
                        font-size: 12px;
                        opacity: 0.9;
                    }
                    
                    .step-arrow {
                        color: white;
                        font-size: 20px;
                        opacity: 0.7;
                    }
                    
                    .alert {
                        border-radius: 8px;
                        font-size: 14px;
                        margin-bottom: 0;
                    }
                    
                    .btn:disabled {
                        opacity: 0.6;
                        cursor: not-allowed;
                    }
                    
                    @media (max-width: 768px) {
                        .otp-box {
                            width: 45px;
                            height: 55px;
                            font-size: 24px;
                        }
                        
                        .verification-steps {
                            flex-direction: column;
                            gap: 15px;
                        }
                        
                        .step-arrow {
                            transform: rotate(90deg);
                        }
                    }
                `}</style>

                {/* FontAwesome CDN */}
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                />
            </div>
        );
    }
}